export default {"src":"/_next/static/media/dxbstay-dark-logo.ca8a8fbc.svg","height":139,"width":503};